"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerWidgetEvent = void 0;
var ServerWidgetEvent;
(function (ServerWidgetEvent) {
    ServerWidgetEvent["getNameByUniqueName"] = "getNameByUniqueNameWidget";
})(ServerWidgetEvent || (exports.ServerWidgetEvent = ServerWidgetEvent = {}));
//# sourceMappingURL=ServerWidgetEvent.js.map